/* eslint-disable jsx-a11y/anchor-is-valid */
import { Link } from 'react-router-dom';

function email(original, props, accessorFunctionsAdditional) {
  return (
    <Link to={accessorFunctionsAdditional.navigate(original.id)}>
      {original?.email || ''}
    </Link>
  );
}

function enabled(original) {
  return original?.enabled ? 'Enabled' : 'Disabled';
}

export { email, enabled };
